"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputChart = void 0;
const crate_1 = require("@tcc/crate");
const react_1 = __importStar(require("react"));
const LineChartContext_1 = require("@/components/LineChart/context/LineChartContext");
const styles_css_1 = require("./styles.css");
exports.InputChart = (0, react_1.memo)((_a) => {
    var { dotIndex = 0, className = '' } = _a, rest = __rest(_a, ["dotIndex", "className"]);
    const { dots, handleInputChange } = (0, LineChartContext_1.useLineChartDynamicContext)();
    const dot = dots[dotIndex] || { inputValue: '', inputIsInValid: false };
    return (react_1.default.createElement(crate_1.TextInput, Object.assign({ value: dot.inputValue, onChange: ({ target }) => {
            handleInputChange(target.value, dotIndex);
        }, className: `${styles_css_1.inputField} ${className}`, type: "number", showReset: false, showLabel: false, error: dot.inputIsInValid }, rest)));
});
exports.InputChart.displayName = 'InputChart';
